import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from } from 'rxjs';
import { CapacitorHttp, HttpOptions } from '@capacitor/core';
import { AppConfig } from 'src/app/app.config';

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {
  
  constructor(private readonly http: HttpClient) { }


  b2cTokenApi(code: string, code_verifier: string){
    let url  = AppConfig.settings?.B2C_LOGIN_AUTHORITY +
    '/oauth2/v2.0/token' +
    `?client_id=${AppConfig.settings?.B2C_CLIENT_ID}` +
    `&grant_type=authorization_code` +
    `&redirect_uri=${AppConfig.settings?.B2C_REDIRECT_URI}` +
    `&scope=${AppConfig.settings?.B2C_USER_TOKEN_SCOPE}` +
    `&code_verifier=${code_verifier}` +
    `&code=${code}`;
    return this.http.get(url, {headers: {skip:"true"}});
  }

  b2cRefreshTokenApi(refresh_token: string) {
    let url= AppConfig.settings?.B2C_LOGIN_AUTHORITY +
      '/oauth2/v2.0/token' +
      `?client_id=${AppConfig.settings?.B2C_CLIENT_ID}` +
      `&grant_type=refresh_token` +
      `&redirect_uri=${AppConfig.settings?.B2C_REDIRECT_URI}` +
      `&scope=${AppConfig.settings?.B2C_USER_TOKEN_SCOPE}` +
      `&refresh_token=${refresh_token}`
    return this.http.get(url, {headers: {skip:"true"}});
  }

  signalRTokenApi(userId: string, data: any) {
    const options: HttpOptions = {
      url: AppConfig.settings?.SIGNALR_WRAPPER_API_BASE_URL + '/negotiate',
      headers: {
        'x-ms-client-principal-id': userId,
        'Content-Type': 'application/json',
        'skip': 'true'
      },
      data
    };
    return from(CapacitorHttp.post(options));
  }

  webTokenApi(userId: string, data: any) {
    const url = AppConfig.settings?.CSS_FUNC_APP_PUBLIC_API_BASE_URL + '/web-negotiate';
    return  this.http.post(url, data, {headers: {'x-ms-client-principal-id': userId, skip:"true"}});
  }

  appUpdateCheckApi() {
    const url = AppConfig.settings?.CSS_FUNC_APP_PUBLIC_API_BASE_URL + '/check-mobile-app-update';
    return  this.http.get(url, {headers: {skip:"true"}});
  }

}
